import { createContext, useContext } from "react";

export type Role = "foreman" | "supervisor" | "project_manager" | "admin";
export const ROLE_LABEL: Record<Role, string> = { foreman: "Foreman", supervisor: "Superintendent", project_manager: "Project manager", admin: "Admin" };
export interface Me { id: string; username: string; displayName: string; role: Role; mustChangePassword?: boolean }
export interface AppUser extends Me { disabled: boolean; createdAt: string; updatedAt: string; workEmail?: string }

export const SessionContext = createContext<Me | null>(null);
export const useMe = () => useContext(SessionContext);
export const canApprove = (me: Me | null) => !!me && (me.role === "admin" || me.role === "supervisor" || me.role === "project_manager");
export const canSeeFinancials = (me: Me | null) => !!me && (me.role === "admin" || me.role === "project_manager");
export const isAdmin = (me: Me | null) => me?.role === "admin";
